export const registerBundle = (bundleName, bundleDescriptor) => {
    window.repluggableArtifacts = window.repluggableArtifacts || {};
    if (!(bundleName in window.repluggableArtifacts)) {
        window.repluggableArtifacts[bundleName] = bundleDescriptor;
    }
};
//# sourceMappingURL=bundleInitializer.js.map